import { render } from "./ItemWithKeywordListItem.vue?vue&type=template&id=6af8a76c&scoped=true&lang=pug"
import script from "./ItemWithKeywordListItem.vue?vue&type=script&lang=js"
export * from "./ItemWithKeywordListItem.vue?vue&type=script&lang=js"

import "./ItemWithKeywordListItem.vue?vue&type=style&index=0&id=6af8a76c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af8a76c"]])

export default __exports__